import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { HorizontalMenu } from '../../../../shared/horizontal-menu/HorizontalMenu';

class AlertsMenu extends Component {
    render() {
        return (
            <HorizontalMenu>
                <NavLink
                    className="horizontal-menu-item"
                    to="/alerts/anti-money-laundering"
                >
                    AML
                </NavLink>
                <NavLink className="horizontal-menu-item" to="/alerts/fraud">
                    Fraud
                </NavLink>
                <NavLink
                    className="horizontal-menu-item"
                    to="/alerts/responsible-gambling"
                >
                    RG
                </NavLink>
            </HorizontalMenu>
        );
    }
}

export default AlertsMenu;
